export const API_URL = 'https://api-crm.milvendas.ao/api';